/** Router state from a create or save that tried to publish right away and couldn't. */
export type RequestPageState = { notice?: string };

export function publishedNotice(err: Error): string {
  const code = (err as Error & { code?: unknown }).code;
  return code === 'META_VIDEO_NOT_READY'
    ? 'Saved, but not published yet: Meta is still processing the video. Publish it here once the video is ready.'
    : `Saved, but publishing failed: ${err.message}`;
}
